var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"margin-top":"40px"}},[_c('delivery-detail',{attrs:{"hideDriver":_vm.user.role === 'store'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }